import Title from "../components/Title"
import completedblank from '../images/switchingblankeditor/completedblank.png'
import report from '../images/switchingblankeditor/report.png'
import sourcescheme from '../images/switchingblankeditor/sourcescheme.png'

export const SwitchingBlankEditorContent = () => {
    return <div className="container">
        <div className="article-container">
            <h1>
                Редактор бланков переключений
            </h1>

            <p>
                Бланки переключений (БП) в SCADA — это специальный программный функционал, предназначенный для безопасного, упорядоченного и документированного проведения оперативных переключений на оборудовании (включение/отключение выключателей, разъединителей, запуск/останов агрегатов и т.д.).
            </p>
            <p>
                Преимущество бланка переключений в SCADA: автоматическое или ручное выполнение контролируемых переключений по заданному технологическому сценарию (бланку). SCADA ведёт оператора по этому сценарию шаг за шагом, блокируя неверные действия и проверяя условия перед выполнением каждого шага.
            </p>
            <p>
                Создание бланков переключений выполняется с помощью редактора бланков переключений.
            </p>
            <p>
                Редактор бланков переключений позволяет указать исходное положение оборудования для начала переключений. Если положение оборудования не соответствует исходному, то переключения выполняться не будут до устранения несоответствий.
            </p>
            <Img src={sourcescheme} />
            <p>
                Последовательность действий задается помощью операций, который могут быть следующих видов:
            </p>
            <Table />
            <p>
                Вызов бланков переключений настраивается в редакторе схем помощью элемента "кнопка". При вызове отображается перечень доступных бланков переключений. Для перехода в нужный бланк необходимо нажать на его название.
            </p>
            <Img src={completedblank} />
            <p>
                После выполнения операций переключения доступна выгрузка отчета о прохождении операций в формате PDF, docx и xlsx.
            </p>
            <Img src={report} />
        </div>
    </div>
}
const Img = ({ src }) => {
    return <img className=" w-100" src={src} />
}
const Table = () => {

    return <div class="table-responsive">
        <table className="table table-striped table-bordered">
            <thead className="thead-dark">
                <tr>
                    <th className="table-th">Вид операции</th>
                    <th className="table-th">Какие действия выполняет</th>
                    <th className="table-th">Привязка сигналов</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>группа операций</td>
                    <td>операция позволяет сгруппировать несколько операций по смысловому назначению или для задания перечня автоматически выполняемых операций.</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>операция "Подтверждение"</td>
                    <td>операция, с помощью которой оператор подтверждает готовность выполнения и переход к следующим операциям или действиям (внутри данной операции). В случае автоматического бланка устанавливается только в начале бланка.</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>операция "Управление"</td>
                    <td>в случае ручного управления в бланке вызывается диалог управления;
                        в случае автоматического управления – диалог управления выполняется в фоновом режиме без участия оператора. В фоновом режиме вызывается диалог управления, проверяется возможность управления, если возможность есть, то отправляется команда управления.
                    </td>
                    <td>К операции привязывается сигнал состояния и указывается в какое значение должен перейти сигнал состояния после выполнения операции.</td>
                </tr>
                <tr>
                    <td>операция "Установка/снятие плакатов"</td>
                    <td> в случае ручного управления вызывается диалог установки плаката,
                        в случае автоматического управления установка плаката выполняется в фоновом режиме. </td>
                    <td>К операции привязывается перечень плакатов и указывается какой вид действия с плакатами должен быть выполнен (установка / снятие).</td>
                </tr>
                <tr>
                    <td>операция "Ждать отклика"</td>
                    <td> никаких дополнительных действий от оператора не требуется, выполняется ожидание перехода значения сигнала в заданное значение. </td>
                    <td> К операции привязывается сигнал и указывается в какое значение должен перейти сигнал, чтобы операция ожидание отклика выполнилась и продолжилось выполнение бланка.</td>
                </tr>
            </tbody>
        </table>
    </div>
}